import React, {Component} from 'react';

import {connect} from "react-redux";
import {PropTypes} from "prop-types";
import DatePicker from "react-datepicker";
import SelectBox from "../../../etc/SelectBox"
import Popup from "../../../etc/Popup"

import {bindActionCreators} from "redux";
import * as Actions from "../../../../store/modules/journals";
import {
	getObjectLength,
	objectToQueryString,
	pushUrl,
	getNumberFormat,
	getSelectFormat
} from "../../../../utils/functions"

import {BASE_PATH, JOURNAL_FACET_NAME, FACET_ORDER} from "../../../../wpconfig"

import * as func from "../../../../utils/functions";
import {NavLink} from "react-router-dom";

class SubCollege extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		const record = this.props.record;

		return (
			<div className="tab-data active">
				<div className="department-list-item">
					<div className="item-subject" id={record.category_code}>
						<label className="btn-department-cate cate-1">{record.category_name}</label>
					</div>
					<div className="department-detail-menu-list">
						<div className="list-inner">
							{record.children.map((r, num) => {
								return (
									<div key={num} className="list-cell">
										<NavLink to={BASE_PATH + "department/?record_id=" + r.category_code}
										         className="btn-detail-menu-item">{r.category_name}</NavLink>
									</div>
								)
							})}
						</div>
					</div>
				</div>
			</div>
		)
	}
}

export default SubCollege;

// College.propTypes = {
//     param : PropTypes.object,
//     facet : PropTypes.object,
// };
